<div class="file-upload-container">
    <mat-card class="upload-card" [class.dragging]="isDragging" (dragover)="onDragOver($event)"
        (dragleave)="onDragLeave($event)" (drop)="onFileDropped($event)">
        <mat-card-content class="upload-area">
            <div class="upload-icon">
                <mat-icon>cloud_upload</mat-icon>
            </div>
            <div class="upload-text">
                <h3>{{ singleFile ? 'Arrastra un archivo' : 'Arrastra los archivos' }}</h3>
                <p>o</p>
                <button mat-raised-button color="primary" (click)="fileInput.click()">
                    <mat-icon>file_upload</mat-icon>
                    Seleccionar archivo
                </button>
                <input #fileInput type="file" (change)="onFilesSelected($event)" [accept]="acceptedExtensions"
                    [multiple]="!singleFile" hidden>
            </div>
            <div class="file-restrictions">
                <small>{{ fileRestrictions }}</small>
            </div>
        </mat-card-content>
    </mat-card>

    @if (files.length > 0) {
    <div class="selected-files">
        <div class="files-header">
            <h3>Archivos seleccionados ({{files.length}})</h3>
            <button mat-button color="warn" (click)="clearFiles()">
                <mat-icon>delete_sweep</mat-icon> Descartar todos
            </button>
        </div>

        @for (file of files; track $index) {
        <mat-card class="file-item">
            <div class="file-info">
                <mat-icon class="file-type-icon">
                    {{ getFileIcon(file) }}
                </mat-icon>
                <div class="file-details">
                    <div class="file-name">{{file.name}}</div>
                    <div class="file-size">{{formatFileSize(file.size)}}</div>
                </div>
            </div>
            <button mat-icon-button color="warn" (click)="removeFile($index)" aria-label="Remove file">
                <mat-icon>close</mat-icon>
            </button>
        </mat-card>
        }
    </div>
    }
</div>